import { palette } from '@openx/components-core/lib/theme/paletteV2';

export const FunnelDiscardArrow = ({
  isCurrentValueAllDiscarded,
  ...props
}: { isCurrentValueAllDiscarded: boolean } & React.ComponentProps<'svg'>) => {
  const color = isCurrentValueAllDiscarded ? palette.error.main : palette.background.boxDarkest;
  return (
    <svg width="110" height="41" viewBox="0 0 110 41" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 0C8 30.5 34.5 30.5 98 30.5" stroke={color} strokeWidth="16" />
      <path d="M109.26 30.3544L98.5 39.8889L98.5 20.1623L109.26 30.3544Z" fill={color} stroke={color} />
    </svg>
  );
};
